import { useState } from "react";

export const useExportCsv = ({ fetchFn, params, filename, transform }) => {
  const [isExporting, setIsExporting] = useState(false);

  const exportToCsv = async () => {
    setIsExporting(true);
    try {
      const res = await fetchFn({ ...params, page: 0, size: 99999 });
      const rows = transform ? transform(res) : (res?.data ?? []);

      if (!rows.length) return;

      const headers = Object.keys(rows[0]);
      const csvContent = [
        headers.join(","),
        ...rows.map((row) =>
          headers
            .map((h) => {
              const val = row[h] ?? "";
              return typeof val === "string" &&
                (val.includes(",") || val.includes("\n"))
                ? `"${val.replace(/"/g, '""')}"`
                : val;
            })
            .join(","),
        ),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${filename}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setIsExporting(false);
    }
  };

  return { exportToCsv, isExporting };
};
